(window["webpackJsonpmeg_ui"] = window["webpackJsonpmeg_ui"] || []).push([["index~progress~upload"],{

/***/ 78:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./src/mixins/themeable/index.js
/* harmony default export */ var themeable = ({
  data: function data() {
    return {
      theme: ''
    };
  },
  created: function created() {
    this.theme = window.localStorage.getItem('theme_cls_prefix') || 'theme-normal';
  }
});
// EXTERNAL MODULE: ./src/mixins/sizeable/index.js
var sizeable = __webpack_require__(98);

// EXTERNAL MODULE: external "classnames"
var external_classnames_ = __webpack_require__(2);
var external_classnames_default = /*#__PURE__*/__webpack_require__.n(external_classnames_);

// CONCATENATED MODULE: ./src/components/progress/util.js
function validProgress(progress) {
  if (!progress || progress < 0) {
    return 0;
  }

  if (progress > 100) {
    return 100;
  }

  return progress;
}
// CONCATENATED MODULE: ./src/components/progress/line.jsx
var _excluded = ["from", "to", "direction"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

// util

var sortGradient = function sortGradient(gradients) {
  var tempArr = [];

  for (var _i = 0, _Object$entries = Object.entries(gradients); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        key = _Object$entries$_i[0],
        value = _Object$entries$_i[1];

    var formatKey = parseFloat(key.replace(/%/g, ''));

    if (isNaN(formatKey)) {
      return {};
    }

    tempArr.push({
      key: formatKey,
      value: value
    });
  }

  tempArr = tempArr.sort(function (a, b) {
    return a.key - b.key;
  });
  return tempArr.map(function (_ref) {
    var key = _ref.key,
        value = _ref.value;
    return "".concat(value, " ").concat(key, "%");
  }).join(', ');
};
var handleGradient = function handleGradient(strokeColor) {
  var _strokeColor$from = strokeColor.from,
      from = _strokeColor$from === void 0 ? '#1890ff' : _strokeColor$from,
      _strokeColor$to = strokeColor.to,
      to = _strokeColor$to === void 0 ? '#1890ff' : _strokeColor$to,
      _strokeColor$directio = strokeColor.direction,
      direction = _strokeColor$directio === void 0 ? 'to right' : _strokeColor$directio,
      rest = _objectWithoutProperties(strokeColor, _excluded);

  if (Object.keys(rest).length !== 0) {
    var sortedGradients = sortGradient(rest);
    return {
      backgroundImage: "linear-gradient(".concat(direction, ", ").concat(sortedGradients, ")")
    };
  }

  return {
    backgroundImage: "linear-gradient(".concat(direction, ", ").concat(from, ", ").concat(to, ")")
  };
}; // 类名前缀

var prefix = 'meg-progress-line';
/* harmony default export */ var line = ({
  name: 'Line',
  props: {
    percent: {
      type: Number,
      default: 0
    },
    strokeColor: {
      type: [String, Object]
    },
    strokeWidth: {
      type: Number
    },
    size: {
      type: String
    },
    showInfo: {
      type: Boolean,
      default: true
    },
    strokeLinecap: {
      type: String
    },
    status: {
      type: String
    },
    progressTxt: {
      type: String,
      default: ''
    } // 自定义progress文案

  },
  methods: {},
  created: function created() {},
  render: function render() {
    var h = arguments[0];
    var _this$$props = this.$props,
        strokeWidth = _this$$props.strokeWidth,
        percent = _this$$props.percent,
        size = _this$$props.size,
        strokeColor = _this$$props.strokeColor,
        strokeLinecap = _this$$props.strokeLinecap,
        status = _this$$props.status,
        showInfo = _this$$props.showInfo,
        progressTxt = _this$$props.progressTxt;
    var backgroundProps;

    if (strokeColor && typeof strokeColor !== 'string') {
      backgroundProps = handleGradient(strokeColor);
    } else {
      backgroundProps = {
        background: strokeColor
      };
    }

    var percentStyle = _objectSpread({
      width: "".concat(validProgress(percent), "%"),
      height: "".concat(strokeWidth || (size === 'small' ? 6 : 8), "px"),
      background: strokeColor,
      borderRadius: strokeLinecap === 'square' ? 0 : '100px'
    }, backgroundProps);

    var children;

    if (status === 'error') {
      children = h("div", {
        "class": "".concat(prefix, "-text")
      }, [h("meg-icon", {
        attrs: {
          name: "megui-fill-close-circle"
        }
      })]);
    } else if (status === 'success') {
      children = h("div", {
        "class": "".concat(prefix, "-text")
      }, [h("meg-icon", {
        attrs: {
          name: "megui-fill-check-circle"
        }
      })]);
    } else {
      // 取 slot 或者 progressTxt 属性, slot优先级更高
      var progressTextSlots = this.$slots.default || progressTxt;
      children = h("div", {
        "class": "".concat(prefix, "-text")
      }, [progressTextSlots ? progressTextSlots : "".concat(percent, "%")]);
    }

    return h("div", {
      "class": prefix
    }, [h("div", {
      "class": "".concat(prefix, "-outer")
    }, [h("div", {
      "class": "".concat(prefix, "-inner")
    }, [h("div", {
      "class": "".concat(prefix, "-bg"),
      style: percentStyle
    })])]), showInfo && children]);
  }
});
// EXTERNAL MODULE: ./node_modules/babel-helper-vue-jsx-merge-props/index.js
var babel_helper_vue_jsx_merge_props = __webpack_require__(3);
var babel_helper_vue_jsx_merge_props_default = /*#__PURE__*/__webpack_require__.n(babel_helper_vue_jsx_merge_props);

// CONCATENATED MODULE: ./src/components/progress/circle.jsx



function circle_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function circle_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { circle_ownKeys(Object(source), true).forEach(function (key) { circle_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { circle_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function circle_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


 // 类名前缀

var circle_prefix = 'meg-progress-circle';
/* harmony default export */ var circle = ({
  name: 'Circle',
  props: {
    percent: {
      type: Number,
      default: 0
    },
    width: {
      type: Number,
      default: 140
    },
    strokeWidth: {
      type: Number,
      default: 8
    },
    strokeColor: {
      type: [String, Object]
    },
    strokeLinecap: {
      type: String
    },
    status: {
      type: String
    }
  },
  methods: {},
  render: function render() {
    var h = arguments[0];
    var _this$$props = this.$props,
        width = _this$$props.width,
        strokeWidth = _this$$props.strokeWidth,
        percent = _this$$props.percent,
        strokeColor = _this$$props.strokeColor,
        status = _this$$props.status;
    percent = validProgress(percent); // 边宽

    strokeWidth = width * strokeWidth / 100; // 半径

    var r = (width - strokeWidth) / 2; // 周长

    var len = Math.ceil(2 * Math.PI * r); // 根据周长和百分比计算偏移量 100% => 0; 0% => len;

    var strokeDashoffset = len - len * percent / 100;
    var commonStyle = {
      r: r,
      cx: width / 2,
      cy: width / 2,
      fill: 'none',
      'stroke-width': strokeWidth
    };
    var svgStyle = {
      attrs: {
        width: width,
        height: width
      }
    };
    var circleOuterStyle = {
      attrs: circle_objectSpread({}, commonStyle)
    };
    var circleBgStyle = {
      attrs: circle_objectSpread(circle_objectSpread({}, commonStyle), {}, {
        'stroke-dasharray': "".concat(len, ", ").concat(len),
        'stroke-dashoffset': "".concat(strokeDashoffset, "px")
      }),
      style: {
        stroke: strokeColor
      }
    };
    var children;

    if (status === 'error') {
      children = h("div", {
        "class": "".concat(circle_prefix, "-text")
      }, [h("meg-icon", {
        attrs: {
          name: "megui-close",
          width: "19",
          height: "19"
        }
      })]);
    } else if (status === 'success') {
      children = h("div", {
        "class": "".concat(circle_prefix, "-text")
      }, [h("meg-icon", {
        attrs: {
          name: "megui-check",
          width: "19",
          height: "19"
        }
      })]);
    } else {
      children = h("div", {
        "class": "".concat(circle_prefix, "-text")
      }, [percent, "%"]);
    }

    return h("div", {
      "class": circle_prefix
    }, [h("svg", svgStyle, [h("circle", babel_helper_vue_jsx_merge_props_default()([{
      "class": "".concat(circle_prefix, "-outer")
    }, circleOuterStyle])), h("circle", babel_helper_vue_jsx_merge_props_default()([{
      "class": "".concat(circle_prefix, "-bg")
    }, circleBgStyle]))]), children]);
  }
});
// CONCATENATED MODULE: ./src/components/progress/index.jsx
function progress_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function progress_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { progress_ownKeys(Object(source), true).forEach(function (key) { progress_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { progress_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function progress_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//  全局mixins,from `src/mixins`

 // 样式文件
// import './style/index.scss';



 // 进度条状态。

var ProgressStatuses = ['normal', 'error', 'active', 'success'];
var MegProgress = {
  name: 'MegProgress',
  props: {
    type: {
      type: String,
      default: 'line'
    },
    size: {
      type: String,
      default: 'normal'
    },
    percent: {
      type: Number,
      default: 0
    },
    width: {
      type: Number
    },
    strokeWidth: {
      type: Number
    },
    strokeColor: {
      type: [String, Object]
    },
    status: {
      type: String
    },
    showInfo: {
      type: Boolean,
      default: true
    },
    progressTxt: {
      type: String,
      default: ''
    } // 自定义progress文案

  },
  mixins: [themeable, sizeable["a" /* default */]],
  mounted: function mounted() {},
  beforeCreate: function beforeCreate() {},
  methods: {
    getPercentNumber: function getPercentNumber() {
      var _this$$props = this.$props,
          successPercent = _this$$props.successPercent,
          _this$$props$percent = _this$$props.percent,
          percent = _this$$props$percent === void 0 ? 0 : _this$$props$percent;
      return parseInt(successPercent !== undefined ? successPercent.toString() : percent.toString(), 10);
    },
    getProgressStatus: function getProgressStatus() {
      var status = this.$props.status;

      if (ProgressStatuses.indexOf(status) < 0 && this.getPercentNumber() >= 100) {
        return 'success';
      }

      return status || 'normal';
    }
  },
  render: function render() {
    var h = arguments[0];
    var progressStatus = this.getProgressStatus();
    var type = this.$props.type;
    var progress, classname;
    var props = {
      class: '',
      props: progress_objectSpread(progress_objectSpread({}, this.$props), {}, {
        status: progressStatus
      })
    };

    if (type === 'line') {
      classname = external_classnames_default()(this.theme, this.sizeableClasses, 'meg-progress', "meg-progress-status-".concat(progressStatus), 'width-100');
      progress = h(line, props, [this.$slots.progressTxt]);
    } else {
      classname = external_classnames_default()(this.theme, this.sizeableClasses, 'meg-progress', "meg-progress-status-".concat(progressStatus));
      progress = h(circle, props);
    }

    return h("div", {
      "class": classname
    }, [progress]);
  }
};

MegProgress.install = function (Vue) {
  Vue.component(MegProgress.name, MegProgress);
};

/* harmony default export */ var components_progress = __webpack_exports__["default"] = (MegProgress);

/***/ })

}]);